import React from 'react'
import Skeleton from 'react-loading-skeleton'

const FAQSkeleton = ({cname}) => {
  return (
    <>
      <div className={`faq-skeleton ${cname}`}>
        <div>
          {Array.from({length:6}).map((_,i)=>{
            return(
              <>
                <div className='faq-skeleton-body' key={i}>
                  <Skeleton width={400} height={20} />
                  <div className='right'>
                    <Skeleton circle width={36} height={36} />
                    <Skeleton circle width={36} height={36} />
                  </div>
                </div>
              </>
            )
          })}
        </div>
        <div className='faq-skeleton-body footer'>
          <Skeleton width={250} height={20} />
          <div className='right'>
            <Skeleton width={36} height={36} />
            <Skeleton width={36} height={36} />
          </div>
        </div>
      </div>
    </>
  )
}

export default FAQSkeleton